import React, { createContext, useContext } from 'react';

const PhotoMetadataContext = createContext(null);

export const PhotoMetadataProvider = ({ value, children }) => (
  <PhotoMetadataContext.Provider value={value}>
    {children}
  </PhotoMetadataContext.Provider>
);

export const usePhotoMetadataContext = () => {
  const context = useContext(PhotoMetadataContext);

  if (!context) {
    throw new Error('usePhotoMetadataContext must be used within a PhotoMetadataProvider');
  }

  return context;
};

export default PhotoMetadataContext;
